<template>
  <div class="card mt-4" style="height: auto;">
    <div class="card-body card-more-results p-4">
      <template v-if="!$currentUser">
        <div class="row">
          <div class="col col-12 col-md-6 text-center">
            <p class="t-xxxlr t-600">
              Welcome back!
            </p>
            <router-link :to="{ name: 'login' }" class="btn btn-primary px-4 mb-4">
              <span class="mx-4 t-600">Log in</span>
            </router-link>
          </div>
          <div class="col col-12 col-md-6">
            <p class="t-xxxlr t-600">
              Sign up for 2 days free access
            </p>
            <form
              class="d-flex align-items-center flex-column flex-md-row"
              @submit.prevent="$router.push({ name: 'signup', query: { email, coupon: '2-DAY-TRIAL' } })">
              <input type="text"
                v-model="email"
                class="form-control form-control-lg mr-2"
                placeholder="Enter your professional email"
              />
              <button type="submit" class="btn btn-primary--green-dark px-4 my-1">
                <span class="mx-4 t-600">Sign up</span>
              </button>
            </form>
            <ul class="mt-4 pl-3 pb-2">
              <li>Unlimited queries in all categories</li>
              <li>See all results, create bookmark folders, create alerts</li>
              <li>Get insights from our analytic filters</li>
            </ul>
            <p class="t-600">
              Already signed up? Check your verification email to log in or <router-link class="t-blue" :to="{ name: 'confirmation.resend' }">resend it</router-link>.
            </p>

          </div>
        </div>
      </template>

      <template v-else>
        <div class="row p-2">
          <div class="col col-12">
            <pro-pitch />
          </div>
          <div class="col col-12">
            <a href="https://www.academiclabs.com/academiclabs-get-started" target="_blank" class="btn btn-primary--green-dark px-4 pull-right">
              <span class="mx-4 t-600">Book a demo</span>
            </a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ProPitch from '@/components/pro/Pitch'

export default {
  name: 'freemiumCTA',
  components: {
    ProPitch
  },
  data () {
    return {
      email: ''
    }
  }
}
</script>
